// client/src/components/MiniBarChart.js
// A dependency-free bar chart for small "last 30 days" style visualizations —
// avoids pulling in a full charting library for a handful of simple bars.
import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

const MiniBarChart = ({ data, labelKey, valueKey, formatValue, height = 140 }) => {
  if (!data || data.length === 0) {
    return <Typography variant="body2" color="text.secondary">No data for this period yet.</Typography>;
  }
  const max = Math.max(...data.map((d) => Number(d[valueKey]) || 0), 1);

  return (
    <Stack direction="row" spacing={0.5} alignItems="flex-end" sx={{ height, overflowX: 'auto', pb: 1 }}>
      {data.map((d, i) => {
        const value = Number(d[valueKey]) || 0;
        const barHeight = Math.max((value / max) * (height - 20), 2);
        return (
          <Tooltip key={i} title={`${d[labelKey]}: ${formatValue ? formatValue(value) : value}`}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 10 }}>
              <Box sx={{ width: 10, height: barHeight, bgcolor: 'primary.main', borderRadius: '2px 2px 0 0' }} />
            </Box>
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default MiniBarChart;
